module.exports = __webpack_public_path__ + "img/KH-注册2.bf3e5570.png";